import React, { useEffect, useState } from "react";
import "./Community.css";
import img from "../../Images/Rectangle 20 (2).png";
import { CiMail } from "react-icons/ci";
import heart from "../../Images/Vector (4).png";
import redHeart from "../../Images/red-heart.png";
import whatsapp from "../../Images/Group 534.png";
import send from "../../Images/Vector (11).png";
import img2 from "../../Images/Rectangle 21.png";
import img3 from "../../Images/Rectangle 20 (3).png";
import logo from "../../Images/Group 1171279193.png";
import trash from "../../Images/Vector (15).png";
import noimage from "../../Images/common_Image.jpg";
import Header from "../../Layout/Header";
import { GoDotFill } from "react-icons/go";
import Header2 from "../../Layout/Header2";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FiEdit } from "react-icons/fi";
import HomeService from "../../Services/HomeService";
import { toast } from "react-toastify";
import HttpClientXml from "../../utils/HttpClientXml";
import ClientInHandUpdateModal from "./ClientInHandUpdateModal";
import { floors } from "./Helper";
import PropertyInHandUpdateModal from "./PropertyInHandUpdateModal";
import MediaSlider from "../PropertyList/MediaSlider";
import { IoArrowBackCircleSharp } from "react-icons/io5";

const styles = {
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  modal: {
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "8px",
    width: "40%",
    boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
  },
};

const CommunityDetails = () => {
  const [show, setShow] = useState(false);
  const [userId, setUserId] = useState("");
  const [mediaUploadLoading, setMediaUploadLoading] = useState(false);
  const [clientShow, setClientShow] = useState(false);
  const [isPropertyDealer, setIsPropertyDealer] = useState(false);
  const [modalOpen, setModalOpen] = useState(true);
  const [floor, setFloor] = useState([]);
  const [bhk, setBhk] = useState([]);
  const [ad, setAd] = useState({});
  const [clientInHandResponse, setClientInHandResponse] = useState([]);
  const [imagesForMediaSlider, setImagesForMediaSlider] = useState([]);
  const [isMediaSliderOpen, setIsMediaSliderOpen] = useState(false);
  const [profile, setProfile] = useState({});
  const [clientInHandData, setClientInHandData] = useState({
    advertisementId: "",
    prefferredLocalities: "",
    minBudget: "",
    maxBudget: "",
    floor: "",
    minBhk: "",
    maxBhk: "",
    priceUnit: "",
    minArea: "",
    maxArea: "",
    areaUnit: "",
    requirement: "",
  });
  const [isClientInHandUpdateClicked, setIsClientInHandUpdateClicked] =
    useState(false);
  const [clientInHandEditData, setClientInHandEditData] = useState({});
  const [isFav, setIsFav] = useState(null);

  const location = useLocation();
  const { dealerDetails } = location.state || {};
  console.log("dealer", dealerDetails);

  const [dealer, setDealer] = useState({});

  useEffect(() => {
    if (dealerDetails) {
      setDealer(dealerDetails);
      console.log("Amit", dealerDetails);
      setIsFav(dealerDetails?.isFavorite);
    }
  }, [dealerDetails]);

  // Property in hand requirement code
  const [propertyType, setPropertyType] = useState([]);
  const [propertyInHand, setPropertyInHand] = useState([]);

  const [selectedPropertyType, setSelectedPropertyType] = useState("");
  const [selectedPropertyFor, setSelectedPropertyFor] = useState("");
  const [cityWiseLocality, setCityWiseLocality] = useState([]);
  const [selectedLocality, setSelectedLocality] = useState("");
  const [cityWiseApartment, setCityWiseApartment] = useState([]);
  const [selectedApartment, setSelectedApartment] = useState("");
  const [selectedAreaUnit, setSelectedAreaUnit] = useState("");
  const [selectedOwnerType, setSelectedOwnerType] = useState("");
  const [selectedPriceUnit, setSelectedPriceUnit] = useState("");
  const [selectedAge, setSelectedAge] = useState("");
  const [selectedLocationUrl, setSelectedLocationUrl] = useState("");
  const [selectedExtra, setSelectedExtra] = useState("");

  const [isPropertyInHandUpdateClicked, setIsPropertyInHandUpdateClicked] =
    useState(false);
  const [propertyInHandUpdateData, setPropertyInHandUpdateData] = useState({});

  const [cities, setCities] = useState([]);
  const [facings, setFacings] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedFacing, setSelectedFacing] = useState("");
  const [locality, setlocality] = useState("");
  const [address, setAddress] = useState("");
  const [area, setArea] = useState("");
  const [selectedBhk, setSelectedBhk] = useState("");

  const [selectedFloor, setSelectedFloor] = useState("");

  const [ownerName, setOwnerName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [price, setPrice] = useState("");
  const [images, setImages] = useState([]);
  const [features, setFeatures] = useState([]);
  const [featureInput, setFeatureInput] = useState("");
  const navigate = useNavigate();

  console.log("EFB77", dealerDetails);

  const getProfile = async () => {
    try {
      const response = await HomeService.getProfile();
      console.log("YTR60", response.data);

      if (response?.status) {
        setProfile(response.data);
      } else {
        console.error("Failed to fetch profile data");
      }
    } catch (error) {
      console.error("Error fetching profile:", error);
    }
  };

  useEffect(() => {
    getProfile();
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  const fetchApartment = async (id) => {
    try {
      console.log("Getting apartment for city ID:", id);
      const res = await HomeService.getAppartmentByCity(id);
      console.log("Apartment response:", res);

      if (res?.status) {
        setCityWiseApartment(res?.data);
        console.log("CityWiseAppartment set:", res?.data);
      } else {
        setCityWiseApartment([]);
      }
    } catch (error) {
      console.error("Failed to fetch Appartment:", error);
      setCityWiseApartment([]);
    }
  };

  const fetchLocality = async (id) => {
    try {
      console.log("Fetching localities for city:", id);
      const res = await HomeService.getLocalitiesByCity(id);
      console.log("Localities response:", res);

      if (res?.status) {
        setCityWiseLocality(res?.data);
        console.log("Localities set:", res?.data);
      }
    } catch (error) {
      console.error("Error fetching localities:", error);
    }
  };

  const fetchPropertyInHand = async () => {
    console.log("DDS80", dealerDetails);

    if (!dealerDetails?._id) {
      console.error("Error: userId is required to fetch properties.");
      return;
    }

    try {
      const response = await HomeService.fetchPropertyInHand(
        dealerDetails?._id,
      );
      console.log("CDE92", response.data);

      if (response?.status) {
        setPropertyInHand(response.data);
      }
    } catch (error) {
      console.error("Error fetching property data:", error);
    }
  };

  useEffect(() => {
    async function fetchPropertyTypes() {
      try {
        const res = await HomeService.getPropertyTypes();

        if (res?.data) {
          setPropertyType(res.data);
        }
      } catch (error) {
        console.error("Error fetching property types:", error);
      }
    }

    async function fetchCities() {
      try {
        const res = await HomeService.getCities({ userId: userId });
        console.log("JHG136", res);
        if (res?.data) {
          setCities(res.data);
        }
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    }

    async function fetchFacings() {
      try {
        const res = await HomeService.getFacings();
        if (res?.data) {
          setFacings(res.data);
        }
      } catch (error) {
        console.error("Error fetching facings:", error);
      }
    }

    fetchPropertyTypes();
    fetchCities();
    fetchFacings();
  }, [userId]);

  useEffect(() => {
    fetchPropertyInHand();
  }, [userId, dealerDetails]);

  useEffect(() => {
    fetchClientInHand();
    fetchPropertyInHand();
  }, [features, clientInHandData, dealerDetails]);

  const fetchClientInHand = async () => {
    const res = await HomeService.getClientInHandById(dealerDetails?._id);
    console.log("WWD186", res.data);

    if (res?.status) {
      setClientInHandResponse(res.data);
    }
  };

  const handleImageUpload = async (e) => {
    const files = e.target.files;
    const uploadedImages = [];

    setMediaUploadLoading(true);

    let completedUploads = 0;

    for (let i = 0; i < files.length; i++) {
      const data = new FormData();
      data.append("image", files[i]);

      try {
        const res = await HttpClientXml.fileUplode(
          "image-upload",
          "POST",
          data,
        );
        if (res?.image) {
          uploadedImages.push(res.image);
        }
      } catch (error) {
        toast.error("Failed to upload image: " + files[i].name);
        console.error("Error uploading image:", error);
      } finally {
        completedUploads++;

        if (completedUploads === files.length) {
          setImages((prevImages) => [...prevImages, ...uploadedImages]);
          setMediaUploadLoading(false);
          toast.success(
            `${uploadedImages.length} images uploaded successfully!`,
          //  " Media uploaded Successfully!"
          );
        }
      }
    }
  };

  const handleAddFeature = () => {
    if (featureInput.trim() !== "") {
      setFeatures((prevFeatures) => [...prevFeatures, featureInput.trim()]);

      setFeatureInput("");
    } else {
      toast.error("Feature cannot be empty");
    }
  };

  const handleRemoveFeature = (featureToRemove) => {
    setFeatures((prevFeatures) =>
      prevFeatures.filter((feature) => feature !== featureToRemove),
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !selectedPropertyType ||
      !selectedCity ||
      !selectedLocality ||
      !selectedPropertyFor
    ) {
      toast.error(
        "Please fill all required fields and upload at least one image.",
      );
      return;
    }

    const matchedPropertyType = propertyType.find(
      (property) => property.propertyType === selectedPropertyType,
    );
    const matchedCity = cities.find((city) => city.name === selectedCity);
    const matchedBhk = bhk.find((bhk) => bhk.bhk === selectedBhk);
    const matchedFloor = floor.find((floor) => floor.floor === selectedFloor);
    const matchedFacing = facings.find(
      (facing) => facing.facing === selectedFacing,
    );
    if (phoneNumber && phoneNumber?.length !== 10) {
      toast.error("Phone Number Should be in 10 digits");
      return;
    }

    if (price && !selectedPriceUnit) {
      toast.error("If You Enter price then please select price unit ");
      return;
    }
    if (area && !selectedAreaUnit) {
      toast.error("If You Enter Area then please select Area unit ");
      return;
    }
    const data = {
      propertyType: selectedPropertyType,
      propertyFor: selectedPropertyFor,
      floor: selectedFloor,
      bhk: selectedBhk,
      aptName: selectedApartment,
      city: selectedCity,
      locality: selectedLocality,
      locationUrl: selectedLocationUrl,
      address,
      area,
      unit: selectedAreaUnit,
      price,
      priceUnit: selectedPriceUnit,
      contactType: selectedOwnerType,
      name: ownerName,
      phoneNo: phoneNumber,
      features,
      age: selectedAge,
      facing: selectedFacing,
      images,
      addedByDealer: userId,
      extra: selectedExtra,
    };

    try {
      const res = await HomeService.postPropertyInHand(data);
      if (res?.status) {
        toast.success("Property added successfully!");

        fetchPropertyInHand();
        setSelectedPropertyType("");
        setSelectedPropertyFor("");
        setSelectedFloor("");
        setSelectedBhk("");
        setSelectedCity("");
        setSelectedLocality("");
        setSelectedLocationUrl("");
        setAddress("");
        setArea("");
        setSelectedAge("");
        setSelectedAreaUnit("");
        setPrice("");
        setSelectedPriceUnit("");
        setSelectedOwnerType("");
        setOwnerName("");
        setPhoneNumber("");
        setFeatures([]);
        setSelectedFacing("");
        setImages([]);
        setSelectedExtra("");
        setSelectedApartment("");
      }
    } catch (error) {
      toast.error("Failed to add property.");
      console.error("Error adding property:", error);
    }
  };

  const handleChange = () => {
    setShow(!show);
  };
  const modalChange = () => {
    setModalOpen(!modalOpen);
  };

  const submitButtonfunc = async (e) => {
    e.preventDefault();
    console.log("submitted data", clientInHandData);
    if (
      !clientInHandData.prefferredLocalities ||
      !clientInHandData?.minBudget ||
      !clientInHandData?.maxBudget ||
      !clientInHandData?.priceUnit ||
      !clientInHandData?.minArea ||
      !clientInHandData?.maxArea ||
      !clientInHandData?.areaUnit ||
      !clientInHandData?.requirement
    ) {
      toast?.error("Please fill All Mandetory Fields!");
      return;
    }
    if (
      Number(clientInHandData?.minBudget) > Number(clientInHandData?.maxBudget)
    ) {
      toast?.error("Min Budget cannot be greater than Max Budget");
      return;
    }

    if (Number(clientInHandData?.minArea) > Number(clientInHandData?.maxArea)) {
      toast.error("Min Area Cannot be greater than Max Area");
      return;
    }

    if (Number(clientInHandData?.minBhk) > Number(clientInHandData?.maxBhk)) {
      toast.error("Min BHK Cannot be greater than Max BHK");
      return;
    }

    const res = await HomeService.postClientInHandRequirement({
      ...clientInHandData,
      minBudget: Number(clientInHandData?.minBudget),
      maxBudget: Number(clientInHandData?.maxBudget),
    });

    if (res?.status) {
      toast?.success(res?.message);
      setClientInHandData({
        advertisementId: "",
        prefferredLocalities: "",
        minBudget: "",
        maxBudget: "",
        floor: "",
        minBhk: "",
        maxBhk: "",
        priceUnit: "",
        minArea: "",
        maxArea: "",
        areaUnit: "",
        requirement: "",
      });
    } else {
      toast?.error(res?.message);
    }
  };

  const fetchLoginProfile = async () => {
    const response = await HomeService.getLoginProfile();
    console.log("ASD331", response?.data);
    if (!response.status) {
      navigate("/profile");
    }
    if (response?.status) {
      setUserId(response?.data?._id);
    }
  };

  const fetchAllFloor = async () => {
    const response = await HomeService.getFloors();
    if (response?.status) {
      setFloor(response?.data);
    }
  };
  const fetchAllBhk = async () => {
    const response = await HomeService.getBhks();
    if (response?.status) {
      setBhk(response?.data);
    }
  };

  useEffect(() => {
    fetchLoginProfile();
  }, [userId]);

  useEffect(() => {
    if (dealerDetails?._id === userId) {
      setIsPropertyDealer(true);

      setClientInHandData((prevData) => ({
        ...prevData,
        advertisementId: dealerDetails?._id,
      }));
    }
  }, [userId, dealerDetails]);

  const goBack = (e) => {
    e.preventDefault();
    console.log("POI419", userId, dealerDetails?._id);
    setIsPropertyDealer(false);
    // Navigate back to the community list
    navigate("/communitylist", { state: {}, replace: true });
  };

  const [showUpdateProfileModal, setShowUpdateProfileModal] = useState(false);
  console.log("YYPOI414", dealerDetails);

  const initialUpdateData = {
    fullName: "",
    email: "",
    mobileNo: "",
    companyName: "",
    city: "",
    workExpYear: "",
    address: "",
  };
  const [updateData, setUpdateData] = useState(initialUpdateData);

  useEffect(() => {
    setUpdateData({
      image: dealerDetails?.image,
      logo: dealerDetails?.logo,
      fullName: dealerDetails?.fullName,
      email: dealerDetails?.email,
      mobileNo: dealerDetails?.mobileNo,
      companyName: dealerDetails?.companyName,
      city: dealerDetails?.city?._id,
      workExpYear: dealerDetails?.workExpYear,
      address: dealerDetails?.address,
      businessField: dealerDetails?.businessField
    });
  }, [dealerDetails]);

  const handleProfileImageUpload = async (e) => {
    const files = e.target.files;
    const uploadedImages = [];

    for (let i = 0; i < files.length; i++) {
      const data = new FormData();
      data.append("image", files[i]);

      try {
        const res = await HttpClientXml.fileUplode(
          "image-upload",
          "POST",
          data,
        );
        if (res?.image) {
          setUpdateData({ ...updateData, [e.target.name]: res.image });
        }
      } catch (error) {
        toast.error("Failed to upload image: " + files[i].name);
        console.error("Error uploading image:", error);
      }
    }

    setImages((prevImages) => [...prevImages, ...uploadedImages]);
    toast.success("Images uploaded successfully!");
    // toast.success("Images uploaded successfully!");
  };

  const updateProfileData = async (e) => {
    e.preventDefault();
    console.log("TTR427", updateData);
    try {
      const res = await HomeService.updateProfile(updateData);

      if (res?.status) {
        toast.success("Profile updated successfully!");
        setShowUpdateProfileModal(!showUpdateProfileModal);
        setDealer({ ...updateData });
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      toast.error("Failed to add property.");
      console.error("Error adding property:", error);
    }
  };

  console.log("fav", dealer?.isFavorite);
  const handleFavourite = async (id) => {
    try {
      const res = await HomeService.makeFavouriteCommunity({
        communityUserId: id,
      });

      if (res?.status) {
        toast.success(res?.message);
        setIsFav(!isFav);
      } else {
        toast.error(toast.message);
      }
    } catch (error) {
      console.error("Error adding favourite:", error);
    }
  };

  const handleShareClick = () => {
    const emailAddress = dealerDetails?.email || dealer?.email || "";
    const body =
      `Hi,\n` +
      `I am ${profile?.fullName}, a real estate broker from the Winner Data Portal. I came across your profile and am interested in the properties you've listed.\n\n` +
      `Please feel free to drop me a message.\n\n` +
      `Website link: https://www.thewinners2.in/\n` +
      `Download link (Android App): https://play.google.com/store/apps/details?id=com.winners.properties`;

    const gmailComposeUrl = `https://mail.google.com/mail/?view=cm&fs=1&body=${encodeURIComponent(body)}&to=${emailAddress}`;

    window.open(gmailComposeUrl, "_blank");
  };

  const handleDeleteClientInHand = async (id) => {
    try {
      const res = await HomeService?.deleteClientHand(id);
      if (res?.status) {
        toast.success(res?.message);
        fetchClientInHand();
      } else {
        toast.error(res?.message);
      }
      console.log("delete", res);
    } catch (error) {
      console.log(error);
      toast.error(error);
    }
  };

  const handleDeletePropertyInHand = async (id) => {
    try {
      const res = await HomeService.deletePropertyInHand(id);
      console.log("delete", res);
    } catch (error) { }
  };

  const openWhatsAppWithMessage = (phoneNumber, message) => {
    const encodedMessage = encodeURIComponent(message);
    const formattedNumber = phoneNumber.replace(/\D/g, "");
    const url = `https://wa.me/${formattedNumber}?text=${encodedMessage}`;
    window.open(url, "_blank");
  };

  const getFirstImage = (mediaUrls) => {
    const imageExtensions = [
      ".jpg",
      ".jpeg",
      ".png",
      ".gif",
      ".webp",
      ".bmp",
      ".svg",
      ".avif",
    ];

    const image = mediaUrls.find((url) => {
      const lowerUrl = url.toLowerCase();
      return imageExtensions.some((ext) => lowerUrl.endsWith(ext));
    });

    return image || "";
  };

  console.log("propertyInHand", propertyInHand);


  return (
    <div className="com">
      <>
        {isMediaSliderOpen && (
          <MediaSlider
            mediaArray={imagesForMediaSlider}
            onClose={() => {
              setIsMediaSliderOpen(false);
            }}
          />
        )}
        <>
          <Header />
          {/* {/* <Header2 /> */}
          {/* <div
            style={{
              paddingLeft: "40px",
              cursor: "pointer",
              fontSize: "20px",
              color: "#0c1666",
              height: "55px",
              width: "55px",
              paddingTop: "20px",
            }}
            onClick={(e) => goBack(e)}
          >
            <IoArrowBackCircleSharp
              style={{ height: "45px", width: "45px" }}
            />
          </div> */}
          <div
            className="back-btn-wrapper"
            onClick={(e) => goBack(e)}
          >
            <IoArrowBackCircleSharp className="back-btn-icon" />
          </div>
          <div className="community_wrapper">
            <div className="community_property_details_wrapper">
              <div className="property_img_details_div">
                <div className="property_img_details_inside_content_wrapper">
                  <div className="property_img_details_content">
                    <div className="community_property_img">
                      <img
                        style={{
                          width: "100%",
                          maxWidth: "100%",
                          minWidth: "100%",
                          objectFit: "cover",
                          height: "100%",
                          borderRadius: "10px",
                        }}
                        src={dealer?.image || dealerDetails?.image}
                        alt="hello"
                      ></img>
                      <div className="community_property_name_div">
                        <p>{dealer?.fullName || dealerDetails?.fullName}</p>
                        <p style={{ fontWeight: "600", color: "#0a591f" }}>
                          {dealer?.companyName || dealerDetails?.companyName}
                        </p>
                      </div>
                      <div className="community_property_logo_div_wrapper5">
                        <img src={dealer?.logo || dealerDetails?.logo}></img>
                      </div>
                    </div>
                    <div className="community_property_names">
                      <div
                        className="d-flex"
                        style={{ display: "flex", columnGap: "5px" }}
                      >
                        <sapn className="first_span">Business Filed:</sapn>
                        <span className="second_span">
                          {dealer?.businessField ||
                            dealerDetails?.businessField}
                        </span>
                      </div>
                      <div style={{ display: "flex", columnGap: "5px" }}>
                        <span className="first_span">Major Locality:</span>
                        <span className="second_span">
                          {dealer?.majorLocality || dealerDetails?.majorLocality}
                        </span>
                      </div>
                      <div style={{ display: "flex", columnGap: "5px" }}>
                        <span className="first_span">
                          Working Experience:
                        </span>
                        <span className="second_span">
                          {dealer?.workExpYear || dealerDetails?.workExpYear}
                        </span>
                      </div>
                    </div>
                    <div className="like_skip_div_wrapper">
                      {!isPropertyDealer ? (
                        <>
                          <div className="like_skip_button_div">
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="like_skip_button_div">
                            <button
                              onClick={() =>
                                setShowUpdateProfileModal(
                                  !showUpdateProfileModal,
                                )
                              }
                              className="skip_btn"
                            >
                              Edit
                            </button>
                          </div>
                        </>
                      )}

                      <div className="community_property_icons_div">
                        {!isPropertyDealer && (
                          <>
                            <div
                              className="icon_no_1"
                              onClick={() => handleFavourite(dealer?._id)}
                              style={{ cursor: "pointer" }}
                            >
                              {console.log("isFav", isFav)}
                              <img
                                alt="heart"
                                src={isFav ? redHeart : heart}
                              ></img>
                            </div>
                          </>
                        )}

                        <div
                          className="icon_no_1"
                          style={{ cursor: "pointer" }}
                          onClick={(e) =>
                            openWhatsAppWithMessage(
                              (
                                dealer?.mobileNo || dealerDetails?.mobileNo
                              ).toString(),
                              `Hi,\n` +
                              `I am ${profile?.fullName}, a real estate broker from the Winner Data Portal. I came across your profile and am interested in the properties you've listed.\n\n ` +
                              `Please feel free to drop me a message.\n\n` +
                              `Website link: https://www.thewinners2.in/\n` +
                              `Download link (Android App): https://play.google.com/store/apps/details?id=com.winners.properties`,
                            )
                          }
                        >
                          <img src={whatsapp}></img>
                        </div>
                        <div
                          className="icon_no_1"
                          style={{ cursor: "pointer" }}
                        >
                          <CiMail
                            style={{
                              fontSize: "20px",
                              color: "red",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleShareClick();
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="client_property_details">
                {console.log("client", clientInHandResponse)}
                {clientInHandResponse.length > 0 ? (
                  <div>
                    {clientInHandResponse?.map((ele) => (
                      <div
                        className="client_in_hand_wrapper"
                        style={{ marginBottom: "3px" }}
                      >
                        <div>
                          <div className="client_head_div">
                            <h3>Client In Hand (Requirement) </h3>
                          </div>

                          <div className="community_form_wrapper_div">
                            <form>
                              <div
                                className="right_client_hand_details_div"
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  rowGap: "8px",
                                }}
                              >
                                <div className="d-flex justify-content-between align-items-center">
                                  <div
                                    className="d-flex justify-content-start align-items-start"
                                    style={{ columnGap: "8px" }}
                                  >
                                    <div>
                                      <p className="preferred_para">
                                        Preferred Localities:
                                      </p>
                                      <p className="city_name">
                                        {ele?.prefferredLocalities}
                                      </p>
                                    </div>
                                  </div>
                                  {isClientInHandUpdateClicked && (
                                    <ClientInHandUpdateModal
                                      onClose={() => {
                                        setIsClientInHandUpdateClicked(false);
                                        fetchClientInHand();
                                      }}
                                      data={clientInHandEditData}
                                    />
                                  )}
                                  {isPropertyDealer ? (
                                    <div
                                      style={{ display: "flex", gap: "10px" }}
                                    >
                                      <i
                                        style={{
                                          fontSize: "24px",
                                          color: "skyblue",
                                          cursor: "pointer",
                                        }}
                                        class="fas fa-edit"
                                        onClick={() => {
                                          setIsClientInHandUpdateClicked(
                                            true,
                                          );
                                          setClientInHandEditData(ele);
                                        }}
                                      ></i>
                                      <div
                                        style={{ cursor: "pointer" }}
                                        className="delete_icon_div"
                                        onClick={() => {
                                          handleDeleteClientInHand(ele?._id);
                                        }}
                                      >
                                        <img src={trash}></img>
                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                                <div
                                  className="d-flex justify-content-start align-items-center"
                                  style={{ columnGap: "8px" }}
                                >
                                  <div>
                                    <p className="preferred_para">Budget:</p>
                                    <p className="city_name">
                                      ₹{ele?.minBudget} {ele?.priceUnit} - ₹
                                      {ele?.maxBudget} {ele?.priceUnit}
                                    </p>
                                  </div>
                                </div>

                                <div
                                  className="d-flex justify-content-start align-items-center"
                                  style={{ columnGap: "8px" }}
                                >
                                  <div>
                                    <p className="preferred_para">Area:</p>
                                    <p className="city_name">
                                      {ele?.minArea} {ele?.areaUnit} -{" "}
                                      {ele?.maxArea} {ele?.areaUnit}
                                    </p>
                                  </div>
                                </div>
                                <div
                                  className="d-flex justify-content-start align-items-center"
                                  style={{ columnGap: "8px" }}
                                >
                                  <div>
                                    <p className="preferred_para">Floor:</p>
                                    <p className="city_name">{ele?.floor}</p>
                                  </div>
                                </div>

                                <div
                                  className="d-flex justify-content-start align-items-center"
                                  style={{ columnGap: "8px" }}
                                >
                                  <div>
                                    <p className="preferred_para">BHK:</p>
                                    <p className="city_name">
                                      {ele?.minBhk} - {ele?.maxBhk}
                                    </p>
                                  </div>
                                </div>
                                <div
                                  className="d-flex justify-content-start align-items-start"
                                  style={{ columnGap: "8px" }}
                                >
                                  <div>
                                    <p className="preferred_para">
                                      REQUIREMENTS:
                                    </p>
                                    <p className="city_name">
                                      {ele?.requirement}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <>
                    <div
                      className="client_in_hand_wrapper"
                      style={{ marginBottom: "3px" }}
                    >
                      <div>
                        <div className="client_head_div">
                          <h3>No Clients found In Hand</h3>
                        </div>
                      </div>
                    </div>
                  </>
                )}

                {isPropertyDealer ? (
                  <div className="client_in_hand_wrapper">
                    <div className="client_head_div">
                      <h3>Client In Hand (Requirement) Form </h3>
                    </div>
                    <div className="community_form_wrapper_div">
                      <form
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          rowGap: "10px",
                        }}
                      >
                        <div className="community_form_filed_wrapper">
                          <label className="community_form_label requiredStar">
                            Preferred Localities
                          </label>
                          <div className="community_input_wrapper_div">
                            <input
                              value={clientInHandData.prefferredLocalities}
                              onChange={(e) => {
                                setClientInHandData((prevData) => ({
                                  ...prevData,
                                  prefferredLocalities: e.target.value,
                                }));
                              }}
                              placeholder="Enter Preferred Localities"
                              type="text"
                            ></input>
                          </div>
                        </div>

                        <div className="community_input_flex_wrapper">
                          <div className="left_form_wrappr">
                            <div className="community_form_filed_wrapper">
                              <label className="community_form_label requiredStar">
                                Min. Budget
                              </label>
                              <div className="community_input_wrapper_div">
                                <input
                                  value={clientInHandData.minBudget}
                                  onChange={(e) => {
                                    if (/^\d*$/.test(e.target.value)) {
                                      setClientInHandData((prev) => ({
                                        ...prev,
                                        minBudget: e.target.value,
                                      }));
                                    }
                                  }}
                                  placeholder="Enter Amount"
                                  type="text"
                                ></input>
                              </div>
                            </div>
                          </div>
                          <div className="right_form_wrapper">
                            <div className="community_form_filed_wrapper">
                              <label className="community_form_label requiredStar">
                                Max. Budget
                              </label>
                              <div className="community_input_wrapper_div">
                                <input
                                  value={clientInHandData.maxBudget}
                                  onChange={(e) => {
                                    if (/^\d*$/.test(e.target.value)) {
                                      setClientInHandData((prev) => ({
                                        ...prev,
                                        maxBudget: e.target.value,
                                      }));
                                    }
                                  }}
                                  placeholder="Enter Amount"
                                  type="text"
                                ></input>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="community_form_filed_wrapper">
                          <label className="community_form_label requiredStar">
                            Price Unit
                          </label>
                          <div className="community_input_wrapper_div">
                            <select
                              type="text"
                              value={clientInHandData.priceUnit}
                              onChange={(e) => {
                                setClientInHandData((prevData) => ({
                                  ...prevData,
                                  priceUnit: e.target.value,
                                }));
                              }}
                            >
                              <option value="">Select Unit</option>
                              <option value="TH">Thousand</option>
                              <option value="LKH">Lakh</option>
                              <option value="CR">Crore</option>
                            </select>
                          </div>
                        </div>

                        <div className="community_input_flex_wrapper">
                          <div className="left_form_wrappr">
                            <div className="community_form_filed_wrapper">
                              <label className="community_form_label requiredStar">
                                Min. Area
                              </label>
                              <div className="community_input_wrapper_div">
                                <input
                                  value={clientInHandData.minArea}
                                  onChange={(e) => {
                                    if (/^\d*$/.test(e.target.value)) {
                                      setClientInHandData((prev) => ({
                                        ...prev,
                                        minArea: e.target.value,
                                      }));
                                    }
                                  }}
                                  placeholder="Enter Area"
                                  type="text"
                                ></input>
                              </div>
                            </div>
                          </div>
                          <div className="right_form_wrapper">
                            <div className="community_form_filed_wrapper">
                              <label className="community_form_label requiredStar">
                                Max. Area
                              </label>
                              <div className="community_input_wrapper_div">
                                <input
                                  value={clientInHandData.maxArea}
                                  onChange={(e) => {
                                    if (/^\d*$/.test(e.target.value)) {
                                      setClientInHandData((prev) => ({
                                        ...prev,
                                        maxArea: e.target.value,
                                      }));
                                    }
                                  }}
                                  placeholder="Enter Area"
                                  type="text"
                                ></input>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="community_form_filed_wrapper">
                          <label className="community_form_label requiredStar">
                            Area Unit
                          </label>
                          <div className="community_input_wrapper_div">
                            <select
                              type="text"
                              value={clientInHandData.areaUnit}
                              onChange={(e) => {
                                setClientInHandData((prevData) => ({
                                  ...prevData,
                                  areaUnit: e.target.value,
                                }));
                              }}
                            >
                              <option value="">Select Unit</option>
                              <option value="Feet">Feet</option>
                              <option value="Yard">Yard</option>
                              <option value="Meter">Meter</option>
                            </select>
                          </div>
                        </div>

                        <div className="community_form_filed_wrapper">
                          <label className="community_form_label ">
                            Floor
                          </label>
                          <div className="community_input_wrapper_div">
                            <input
                              value={clientInHandData.floor}
                              onChange={(e) => {
                                setClientInHandData((prevData) => ({
                                  ...prevData,
                                  floor: e.target.value,
                                }));
                              }}
                              placeholder="Enter Floor"
                              type="text"
                            ></input>
                          </div>
                        </div>

                        <div className="community_input_flex_wrapper">
                          <div className="left_form_wrappr">
                            <div className="community_form_filed_wrapper">
                              <label className="community_form_label ">
                                Min. BHK
                              </label>
                              <div className="community_input_wrapper_div">
                                <input
                                  value={clientInHandData.minBhk}
                                  onChange={(e) => {
                                    if (/^\d*$/.test(e.target.value)) {
                                      setClientInHandData((prev) => ({
                                        ...prev,
                                        minBhk: e.target.value,
                                      }));
                                    }
                                  }}
                                  placeholder="Enter Bhk"
                                  type="text"
                                ></input>
                              </div>
                            </div>
                          </div>
                          <div className="right_form_wrapper">
                            <div className="community_form_filed_wrapper">
                              <label className="community_form_label ">
                                Max. BHK
                              </label>
                              <div className="community_input_wrapper_div">
                                <input
                                  value={clientInHandData.maxBhk}
                                  onChange={(e) => {
                                    if (/^\d*$/.test(e.target.value)) {
                                      setClientInHandData((prev) => ({
                                        ...prev,
                                        maxBhk: e.target.value,
                                      }));
                                    }
                                  }}
                                  placeholder="Enter BHK"
                                  type="text"
                                ></input>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="community_form_filed_wrapper">
                          <label className="community_form_label requiredStar">
                            Fill Your Complete Requirement
                          </label>
                          <div className="community_input_wrapper_div">
                            <textarea
                              placeholder="Enter Preferred Localities"
                              type="text"
                              value={clientInHandData?.requirement}
                              onChange={(e) => {
                                setClientInHandData((prev) => ({
                                  ...prev,
                                  requirement: e?.target?.value,
                                }));
                              }}
                            ></textarea>
                          </div>
                        </div>
                        <div className="community_form_submit_div">
                          <button onClick={(e) => submitButtonfunc(e)}>
                            Submit
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>

            <div className="community_property_details_wrapper2">
              <div className="property_img_details_div2">
                {propertyInHand.length > 0 ? (
                  <div>
                    <h1 className="prefered_cities_head2">
                      Property In Hand
                    </h1>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        rowGap: "20px",
                      }}
                    >
                      {propertyInHand?.map((e, i) => {
                        return (
                          <>
                            <div className="property_img_details_inside_content_wrapper2">
                              <div className="community_property_img5">
                                <img
                                  src={getFirstImage(e?.images) || noimage}
                                  alt="hello"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    setIsMediaSliderOpen(true);
                                    setImagesForMediaSlider(e?.images);
                                  }}
                                ></img>
                              </div>

                              <div className="community_property_details_wrapper5">
                                <div className="community_property_details_5">
                                  <div className="community_property_5">
                                    <div className="property_para_div">
                                      <p className="property_data_para">
                                        Property Type:
                                      </p>
                                      <p className="property_data_para2">
                                        {e?.propertytype?.propertyType}
                                      </p>
                                    </div>

                                    <div className="property_para_div">
                                      <p className="property_data_para">
                                        BHK:
                                      </p>
                                      <p className="property_data_para2">
                                        {e?.bhk}
                                      </p>
                                    </div>
                                    {isPropertyDealer && (
                                      <div
                                        style={{
                                          display: "flex",
                                          gap: "15px",
                                        }}
                                      >
                                        <i
                                          style={{
                                            fontSize: "22px",
                                            color: "skyblue",
                                            cursor: "pointer",
                                            marginLeft: "10px",
                                          }}
                                          class="fas fa-edit"
                                          onClick={() => {
                                            setIsPropertyInHandUpdateClicked(
                                              true,
                                            );
                                            setPropertyInHandUpdateData(e);
                                          }}
                                        ></i>
                                      </div>
                                    )}
                                  </div>
                                  <div className="community_property_5">
                                    <div className="property_para_div">
                                      <p className="property_data_para">
                                        Address:
                                      </p>
                                      <p className="property_data_para2">
                                        {e?.address}
                                      </p>
                                    </div>

                                    <div className="property_para_div">
                                      <p className="property_data_para">
                                        Contact:
                                      </p>
                                      <p className="property_data_para2">
                                        {e?.phoneNo}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="community_property_5">
                                    <div className="property_para_div">
                                      <p className="property_data_para">
                                        Area:
                                      </p>
                                      <p className="property_data_para2">
                                        {e?.area}
                                      </p>
                                    </div>

                                    <div className="property_para_div">
                                      <p className="property_data_para">
                                        Extra:
                                      </p>
                                      <p className="property_data_para2">
                                        {e?.extra}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="community_property_5">
                                    <div className="property_para_div">
                                      <p className="property_data_para">
                                        Floor:
                                      </p>
                                      <p className="property_data_para2">
                                        {e?.floor}
                                      </p>
                                    </div>
                                  </div>
                                  {isPropertyInHandUpdateClicked && (
                                    <PropertyInHandUpdateModal
                                      onClose={() => {
                                        setIsPropertyInHandUpdateClicked(false);
                                        fetchPropertyInHand();
                                      }}
                                      isOpen={isPropertyInHandUpdateClicked}
                                      propertyData={propertyInHandUpdateData}
                                      userId={userId}
                                    />
                                  )}
                                  {
                                    <div className="property_icons_div5">
                                      <div
                                        style={{
                                          padding: "10px 15px 10px 0px",
                                          display: "flex",
                                          justifyContent: "space-between",
                                        }}
                                      >
                                        {/* {isPropertyDealer && (
                                          <div
                                            style={{
                                              display: "flex",
                                              gap: "15px",
                                            }}
                                          >
                                            <i
                                              style={{
                                                fontSize: "22px",
                                                color: "skyblue",
                                                cursor: "pointer",
                                                marginLeft: "10px",
                                              }}
                                              class="fas fa-edit"
                                              onClick={() => {
                                                setIsPropertyInHandUpdateClicked(
                                                  true,
                                                );
                                                setPropertyInHandUpdateData(e);
                                              }}
                                            ></i>
                                          </div>
                                        )} */}
                                      </div>
                                    </div>
                                  }
                                </div>
                              </div>
                            </div>
                          </>
                        );
                      })}
                    </div>
                  </div>
                ) : (
                  <>
                    <div>
                      <h1 className="prefered_cities_head2">
                        No Properties found in hand
                      </h1>
                    </div>
                  </>
                )}
              </div>

              {isPropertyDealer ? (
                <div className="client_property_details2">
                  <div className="client_in_hand_wrapper">
                    <div className="client_head_div">
                      <h3>Property In Hand (Requirement) Form </h3>
                    </div>
                    <div className="community_form_wrapper_div ">
                      <form
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          rowGap: "10px",
                        }}
                        onSubmit={handleSubmit}
                      >
                        <div className="row">
                          <div className="community_input_wrapper_div mt-3">
                            <label className="requiredStar">
                              Property Type{" "}
                            </label>
                            <select
                              value={selectedPropertyType}
                              onChange={(e) =>
                                setSelectedPropertyType(e.target.value)
                              }
                              required
                            >
                              <option value="">Select Property Type</option>
                              {propertyType.map((type) => (
                                <option key={type._id} value={type._id}>
                                  {type.propertyType}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="community_input_wrapper_div mt-3">
                            <label className="requiredStar">
                              Property For{" "}
                            </label>
                            <select
                              value={selectedPropertyFor}
                              onChange={(e) =>
                                setSelectedPropertyFor(e.target.value)
                              }
                              required
                            >
                              <option value="">Select Property For</option>
                              <option value="sale">Sale</option>
                              <option value="rent">Rent</option>
                            </select>
                          </div>

                          <div className="community_input_wrapper_div mt-3">
                            <label className="requiredStar">City</label>
                            <select
                              value={selectedCity}
                              onChange={(e) => {
                                setSelectedCity(e.target.value);
                                fetchLocality(e?.target?.value);
                                fetchApartment(e?.target?.value);
                              }}
                              required
                            >
                              <option value="">Select City</option>
                              {cities.map((city) => (
                                <option key={city._id} value={city?._id}>
                                  {city.name}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="community_input_wrapper_div mt-3">
                            <label className="requiredStar">Locality</label>
                            <select
                              value={selectedLocality}
                              onChange={(e) => {
                                setSelectedLocality(e.target.value);
                              }}
                              required
                              disabled={!selectedCity}
                            >
                              <option value="">Select Locality</option>
                              {cityWiseLocality.map((item, i) => (
                                <option key={i} value={item?._id}>
                                  {item?.name}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="community_input_wrapper_div mt-3">
                            <label>Apartment</label>
                            <select
                              value={selectedApartment}
                              onChange={(e) => {
                                setSelectedApartment(e.target.value);
                              }}
                              disabled={!selectedLocality}
                            >
                              <option value="">Select Apartment</option>
                              {cityWiseApartment
                                ?.filter(
                                  (item) =>
                                    item?.locality?._id === selectedLocality,
                                )
                                ?.map((item, i) => (
                                  <option key={i} value={item?.aptName}>
                                    {item?.aptName}
                                  </option>
                                ))}
                            </select>
                          </div>

                          <div className="community_input_wrapper_div mt-3">
                            <label>Address</label>
                            <input
                              type="text"
                              className="form-control"
                              value={address}
                              onChange={(e) => setAddress(e.target.value)}
                              placeholder="Enter Address"
                            />
                          </div>

                          <div className="community_input_wrapper_div mt-3">
                            <label>Area</label>
                            <input
                              type="text"
                              className="form-control"
                              value={area}
                              onChange={(e) => {
                                if (/^\d*$/.test(e.target.value)) {
                                  setArea(e.target.value);
                                }
                              }}
                              placeholder="Enter Area"
                            />
                          </div>

                          <div className="community_input_wrapper_div mt-3">
                            <label>Area Unit</label>
                            <select
                              value={selectedAreaUnit}
                              onChange={(e) => {
                                setSelectedAreaUnit(e.target.value);
                              }}
                              disabled={!area}
                            >
                              <option value="">Select Area Unit</option>
                              <option value="Feet">Feet</option>
                              <option value="Yard">Yard</option>
                              <option value="Meter">Meter</option>
                            </select>
                          </div>

                          <div className="community_input_wrapper_div mt-3">
                            <label>BHK</label>
                            <select
                              value={selectedBhk}
                              onChange={(e) => setSelectedBhk(e.target.value)}
                            >
                              <option value="">Select Bhk</option>

                              {[
                                "1",
                                "1RK",
                                "2",
                                "2RK",
                                ...Array.from({ length: 33 }, (_, i) =>
                                  (i + 3).toString(),
                                ),
                              ].map((bhk, i) => (
                                <option key={i} value={bhk}>
                                  {bhk}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div className="community_input_wrapper_div mt-3">
                            <label>Floor</label>
                            <select
                              value={selectedFloor}
                              onChange={(e) =>
                                setSelectedFloor(e.target.value)
                              }
                            >
                              <option value="">Select Floor</option>

                              {floors.map((floor, i) => (
                                <option key={i} value={floor}>
                                  {floor}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div className="community_input_wrapper_div mt-3">
                            <label>Owner Type</label>
                            <select
                              value={selectedOwnerType}
                              onChange={(e) =>
                                setSelectedOwnerType(e.target.value)
                              }
                            >
                              <option value="">Select Owner Type</option>
                              <option value="Owner">Owner</option>
                              <option value="Builder">Builder</option>
                              <option value="Dealer">Dealer</option>
                            </select>
                          </div>

                          <div className="community_input_wrapper_div mt-3">
                            <label>Owner Name</label>
                            <input
                              type="text"
                              className="form-control"
                              value={ownerName}
                              onChange={(e) => setOwnerName(e.target.value)}
                              placeholder="Enter Owner Name"
                            />
                          </div>
                          <div className="community_input_wrapper_div mt-3">
                            <label>Phone Number</label>
                            <input
                              type="tel"
                              className="form-control"
                              value={phoneNumber}
                              onChange={(e) => {
                                if (/^\d*$/.test(e.target.value)) {
                                  setPhoneNumber(e?.target?.value);
                                }
                              }}
                              placeholder="Enter Phone Number"
                            />
                          </div>

                          <div className="community_input_wrapper_div mt-3">
                            <label>Price</label>
                            <input
                              type="text"
                              className="form-control"
                              value={price}
                              onChange={(e) => {
                                if (/^\d*$/.test(e.target.value)) {
                                  setPrice(e.target.value);
                                }
                              }}
                              placeholder="Enter Price"
                            />
                          </div>

                          <div className="community_input_wrapper_div mt-3">
                            <label>Price Unit</label>
                            <select
                              value={selectedPriceUnit}
                              onChange={(e) =>
                                setSelectedPriceUnit(e.target.value)
                              }
                            >
                              <option value="">Select Price Unit</option>
                              <option value="TH">Thousand</option>
                              <option value="LKH">Lakh</option>
                              <option value="CR">Crore</option>
                            </select>
                          </div>

                          <div className="community_input_wrapper_div mt-3">
                            <label>Facing</label>
                            <select
                              value={selectedFacing}
                              onChange={(e) =>
                                setSelectedFacing(e.target.value)
                              }
                            >
                              <option value="">Select Facing</option>
                              {facings.map((facing) => (
                                <option key={facing._id} value={facing._id}>
                                  {facing.facing}
                                </option>
                              ))}
                            </select>
                          </div>

                          {/* Features Input */}
                          <div className="community_input_wrapper_div mt-3">
                            <label>Features</label>
                            <div className="d-flex align-items-center gap-2 add_features">
                              <input
                                type="text"
                                className="form-control"
                                value={featureInput}
                                onChange={(e) =>
                                  setFeatureInput(e.target.value)
                                }
                                placeholder="Enter a feature"
                              />
                              <button
                                type="button"
                                className="btn btn-secondary ml-2"
                                onClick={handleAddFeature}
                              >
                                Add
                              </button>
                            </div>
                            <div className="mt-2">
                              {features.map((feature, index) => (
                                <span
                                  key={index}
                                  className="badge badge-primary mr-2"
                                  style={{
                                    display: "inline-block",
                                    backgroundColor: "#007bff",
                                    color: "#fff",
                                    padding: "8px 12px",
                                    borderRadius: "20px",
                                    fontSize: "14px",
                                    margin: "5px",
                                    cursor: "pointer",
                                    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
                                    transition: "all 0.3s ease",
                                  }}
                                  onClick={() => handleRemoveFeature(feature)}
                                >
                                  {feature}{" "}
                                  <span
                                    style={{
                                      marginLeft: "5px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    ×
                                  </span>
                                </span>
                              ))}
                            </div>
                          </div>

                          <div className="community_input_wrapper_div mt-3">
                            <label>Age</label>
                            <input
                              type="text"
                              className="form-control"
                              value={selectedAge}
                              onChange={(e) => setSelectedAge(e.target.value)}
                              placeholder="Enter Age"
                            />
                          </div>
                          <div className="community_input_wrapper_div mt-3">
                            <label>Location URL</label>
                            <input
                              type="text"
                              className="form-control"
                              value={selectedLocationUrl}
                              onChange={(e) =>
                                setSelectedLocationUrl(e.target.value)
                              }
                              placeholder="Enter Location Url"
                            />
                          </div>

                          <div className="community_input_wrapper_div mt-3">
                            <label>Upload Images + Videos</label>
                            <input
                              type="file"
                              className="form-control"
                              onChange={handleImageUpload}
                              multiple
                              accept="image/*,video/*"
                            />

                            {mediaUploadLoading
                              ? "Uploading Media..."
                              : images.length > 0 && (
                                <div className="community_input_wrapper_div mt-3">
                                  <label>Media Preview:</label>
                                  <div className="d-flex flex-wrap">
                                    {images.map((img, index) => {
                                      if (
                                        img?.endsWith(
                                          ".mp4" ||
                                          ".webm" ||
                                          ".mov" ||
                                          ".avi" ||
                                          ".wmv" ||
                                          ".flv" ||
                                          ".mkv" ||
                                          ".mpeg" ||
                                          ".mpg",
                                        )
                                      ) {
                                        return (
                                          <video
                                            key={index}
                                            src={img}
                                            controls
                                            style={{
                                              width: "100px",
                                              height: "100px",
                                              margin: "5px",
                                              objectFit: "cover",
                                            }}
                                          />
                                        );
                                      } else {
                                        return (
                                          <img
                                            key={index}
                                            src={img}
                                            alt={`Preview ${index + 1}`}
                                            style={{
                                              width: "100px",
                                              height: "100px",
                                              margin: "5px",
                                            }}
                                          />
                                        );
                                      }
                                    })}
                                  </div>
                                </div>
                              )}
                          </div>
                          <div className="community_input_wrapper_div mt-3">
                            <label>Extra</label>
                            <textarea
                              type="text"
                              className="form-control"
                              value={selectedExtra}
                              onChange={(e) =>
                                setSelectedExtra(e.target.value)
                              }
                              placeholder="Enter Extra"
                            />
                          </div>
                        </div>
                        <div className="community_form_submit_div">
                          <button>Submit</button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </>
      </>

      {showUpdateProfileModal && (
        <div style={styles.modalOverlay}>
          <div style={styles.modal}>
            <div className="client_in_hand_wrapper">
              <div className="client_head_div">
                <h3>Update Profile </h3>
              </div>
              <div className="community_form_wrapper_div">
                <form
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    rowGap: "10px",
                  }}
                >
                  <div className="community_input_flex_wrapper">
                    <div className="left_form_wrappr">
                      <div className="community_form_filed_wrapper">
                        <label className="community_form_label">Banner</label>
                        <div className="community_input_wrapper_div">
                          <img
                            src={updateData?.image}
                            style={{ maxHeight: "50px", maxWidth: "100%" }}
                          />
                          <input
                            type="file"
                            name="image"
                            className="form-control"
                            onChange={(e) => handleProfileImageUpload(e)}
                            accept="image/*"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="community_form_filed_wrapper">
                      <label className="community_form_label">Logo</label>
                      <div className="community_input_wrapper_div">
                        <img
                          src={updateData?.logo}
                          style={{ maxHeight: "50px", maxWidth: "100%" }}
                        />
                        <input
                          type="file"
                          name="logo"
                          className="form-control"
                          onChange={(e) => handleProfileImageUpload(e)}
                          accept="image/*"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="community_input_flex_wrapper">
                    <div className="left_form_wrappr">
                      <div className="community_form_filed_wrapper">
                        <label className="community_form_label">Name</label>
                        <div className="community_input_wrapper_div">
                          <input
                            value={updateData?.fullName}
                            onChange={(e) =>
                              setUpdateData({
                                ...updateData,
                                fullName: e.target.value,
                              })
                            }
                            placeholder="Full name"
                            type="text"
                          ></input>
                        </div>
                      </div>
                    </div>
                    <div className="community_form_filed_wrapper">
                      <label className="community_form_label">Email</label>
                      <div className="community_input_wrapper_div">
                        <input
                          value={updateData?.email}
                          onChange={(e) =>
                            setUpdateData({
                              ...updateData,
                              email: e.target.value,
                            })
                          }
                          placeholder="Email address"
                          type="text"
                        ></input>
                      </div>
                    </div>
                  </div>

                  <div className="community_input_flex_wrapper">
                    <div className="left_form_wrappr">
                      <div className="community_form_filed_wrapper">
                        <label className="community_form_label">Phone</label>
                        <div className="community_input_wrapper_div">
                          <input
                            value={updateData?.mobileNo}
                            onChange={(e) =>
                              setUpdateData({
                                ...updateData,
                                mobileNo: e.target.value,
                              })
                            }
                            placeholder="Phone number"
                            type="text"
                          ></input>
                        </div>
                      </div>
                    </div>
                    <div className="community_form_filed_wrapper">
                      <label className="community_form_label">Company</label>
                      <div className="community_input_wrapper_div">
                        <input
                          value={updateData?.companyName}
                          onChange={(e) =>
                            setUpdateData({
                              ...updateData,
                              companyName: e.target.value,
                            })
                          }
                          placeholder="Company name"
                          type="text"
                        ></input>
                      </div>
                    </div>
                  </div>

                  <div className="community_input_flex_wrapper">
                    <div className="left_form_wrappr">
                      <div className="community_form_filed_wrapper">
                        <label className="community_form_label">City</label>
                        <div className="community_input_wrapper_div">
                          <select
                            value={updateData?.city}
                            onChange={(e) =>
                              setUpdateData({
                                ...updateData,
                                city: e.target.value,
                              })
                            }
                          >
                            <option value="">Select City</option>
                            {cities.map((city) => (
                              <option key={city._id} value={city._id}>
                                {city.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="community_form_filed_wrapper">
                      <label className="community_form_label">
                        Work Experience
                      </label>
                      <div className="community_input_wrapper_div">
                        <input
                          value={updateData?.workExpYear}
                          onChange={(e) =>
                            setUpdateData({
                              ...updateData,
                              workExpYear: e.target.value,
                            })
                          }
                          placeholder="Work Experience in years"
                          type="text"
                        ></input>
                      </div>
                    </div>
                  </div>

                  <div className="community_form_filed_wrapper">
                    <label className="community_form_label">Address</label>
                    <div className="community_input_wrapper_div">
                      <input
                        value={updateData?.address}
                        onChange={(e) =>
                          setUpdateData({
                            ...updateData,
                            address: e.target.value,
                          })
                        }
                        placeholder="Major localities"
                        type="text"
                      ></input>
                    </div>
                  </div>
                  <div className="community_form_filed_wrapper">
                    <label className="community_form_label">Business Fields</label>
                    <div className="community_input_wrapper_div">
                      <input
                        value={updateData?.businessField}
                        onChange={(e) =>
                          setUpdateData({
                            ...updateData,
                            businessField: e.target.value,
                          })
                        }
                        placeholder="Business Fields"
                        type="text"
                      ></input>
                    </div>
                  </div>

                  <div className="community_form_submit_div">
                    <button onClick={(e) => updateProfileData(e)}>
                      Submit
                    </button>
                    <button
                      style={{ marginLeft: "1em" }}
                      onClick={() => {
                        setUserId("");
                        fetchLoginProfile();
                        setShowUpdateProfileModal(!showUpdateProfileModal);
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CommunityDetails;
